'use client'

import { useState, useEffect } from 'react'

const AUTH_STORAGE_KEY = 'runara-engine-auth'
const AUTH_STORAGE_VALUE = '1'
const ENGINE_PASSWORD = 'Runaraplaytimezero'

interface PasswordGateProps {
  children: React.ReactNode
}

export default function PasswordGate({ children }: PasswordGateProps) {
  const [unlocked, setUnlocked] = useState<boolean | null>(null)
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    const stored = typeof window !== 'undefined' ? localStorage.getItem(AUTH_STORAGE_KEY) : null
    setUnlocked(stored === AUTH_STORAGE_VALUE)
  }, [])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (password === ENGINE_PASSWORD) {
      localStorage.setItem(AUTH_STORAGE_KEY, AUTH_STORAGE_VALUE)
      setUnlocked(true)
    } else {
      setError('Incorrect password')
    }
  }

  if (unlocked === null) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-300" />
      </div>
    )
  }

  if (unlocked) {
    return <>{children}</>
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white">
      <div className="w-full max-w-sm rounded-lg bg-gray-800 border border-gray-700 p-6 shadow-xl">
        <h1 className="text-xl font-semibold text-center mb-1">Runara Engine</h1>
        <p className="text-gray-400 text-sm text-center mb-6">Enter password to continue</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
              setError('')
            }}
            placeholder="Password"
            className="w-full px-3 py-2 rounded bg-gray-700 border border-gray-600 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            autoFocus
          />
          {error && <p className="text-sm text-red-400">{error}</p>}
          <button
            type="submit"
            className="w-full py-2 rounded bg-purple-600 hover:bg-purple-700 text-white font-medium transition-colors"
          >
            Unlock
          </button>
        </form>
      </div>
    </div>
  )
}
